export default __webpack_public_path__ + "static/media/bg-pattern-big.c890a84d.svg";